export function pickLocalized(map, language = 'en', fallback = '') {
    if (!map) return fallback;
    if (typeof map === 'string') return map;

    const key = String(language || 'en').split('-')[0];
    return map[key] || map.en || Object.values(map).find((v) => typeof v === 'string' && v.trim()) || fallback;
}
